// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otp-modal {
  background-color: #121212 !important;
  border-radius: 0.4vw;
  width: 24vw;
  /* height: 17vw; */
  margin: auto !important;
  position: relative;
}

.field-header {
  font-family: "Poppins" !important;
  font-weight: 300 !important;
  font-size: 1.1vw !important;
  line-height: 100% !important;
  margin-bottom: 1.5vw !important;
}

.otp-label {
  font-family: "Poppins" !important;
  font-weight: 600 !important;
  font-size: 0.9vw !important;
  line-height: 100% !important;
  color: #595959 !important;
  margin-bottom: 1vw !important;
}

.otpBtn {
  background-color: #50c878 !important;
  color: black !important;
  font-family: "Poppins" !important;
  font-size: 0.9vw !important;
  font-weight: 600;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0.4vw !important;
  border-bottom-left-radius: 0.4vw !important;
  &:hover {
    background-color: #2fa456ce !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/otpFields/OtpFieldStyle.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iCAAiC;EACjC,2BAA2B;EAC3B,gBAAgB;EAChB,oCAAoC;EACpC,qCAAqC;EACrC,4CAA4C;EAC5C,2CAA2C;EAC3C;IACE,sCAAsC;EACxC;AACF","sourcesContent":[".otp-modal {\n  background-color: #121212 !important;\n  border-radius: 0.4vw;\n  width: 24vw;\n  /* height: 17vw; */\n  margin: auto !important;\n  position: relative;\n}\n\n.field-header {\n  font-family: \"Poppins\" !important;\n  font-weight: 300 !important;\n  font-size: 1.1vw !important;\n  line-height: 100% !important;\n  margin-bottom: 1.5vw !important;\n}\n\n.otp-label {\n  font-family: \"Poppins\" !important;\n  font-weight: 600 !important;\n  font-size: 0.9vw !important;\n  line-height: 100% !important;\n  color: #595959 !important;\n  margin-bottom: 1vw !important;\n}\n\n.otpBtn {\n  background-color: #50c878 !important;\n  color: black !important;\n  font-family: \"Poppins\" !important;\n  font-size: 0.9vw !important;\n  font-weight: 600;\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0.4vw !important;\n  border-bottom-left-radius: 0.4vw !important;\n  &:hover {\n    background-color: #2fa456ce !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
